/* global facebookPageUserName, communityName */

import get from '../../plugins/get';

export default () => {

  if ($('.community-facebook-post').length) {

    const facebookAPI = 'https://graph.facebook.com/v2.11',
          facebookUser = facebookPageUserName,
          accessToken = '1904889896443226|4e42aa1d0b7cd599b49512cb157713ab',
          fields = 'full_picture,message,link',
          limit = 5,
          type = 'photo',
          query = `${facebookAPI}/${facebookUser}/posts/?access_token=${accessToken}&fields=${fields}&limit=${limit}&type=${type}`;

    // HTTP request with Promise to get latest post
    get(query).then(JSON.parse).then((response) => {

      const post = response.data.find((img) => img.message !== undefined);

      if (post) {

        if (!String.linkify) {
          String.prototype.linkify = function() {

            // http://, https://, ftp://
            const urlPattern = /\b(?:https?|ftp):\/\/[a-z0-9-+&@#/%?=~_|!:,.;]*[a-z0-9-+&@#/%=~_|]/gim;

            // www. sans http:// or https://
            const pseudoUrlPattern = /(^|[^/])(www\.[\S]+(\b|$))/gim;

            // Email addresses
            const emailAddressPattern = /[\w.]+@[a-zA-Z_-]+?(?:\.[a-zA-Z]{2,6})+/gim;

            return this
              .replace(urlPattern, '<a href="$&" target="_blank">$&</a>')
              .replace(pseudoUrlPattern, '$1<a href="http://$2" target="_blank">$2</a>')
              .replace(emailAddressPattern, '<a href="mailto:$&">$&</a>')
            ;
          };
        }

        $('.community-facebook-post-item-image').attr('src', post.full_picture).attr('alt', `Life at ${communityName}`);
        $('.community-facebook-post-item-content').prepend(post.message.linkify());
        $('.community-facebook-post').show();

        setTimeout(() => {

          if (post.message.length < 200) {
            $('.community-facebook-post-item').addClass('-short-text');
          }

          if ($('.community-facebook-post-item-image').height() > $('.community-facebook-post-item-content').height()) {
            $('.community-facebook-post-item').addClass('-vertically-center');
          }

        }, 250);

      }

    });

  }

};
